/**
 * @module @yimoka/i18n/sync/policy
 * @summary 默认同步策略
 * @author keep
 * @since 2026-05-19
 */

import type { I18nSyncPolicy } from '../types';

/** 默认同步策略 */
export const DEFAULT_SYNC_POLICY: I18nSyncPolicy = {
  onStartup: 'local_then_remote',
  backgroundRefresh: true,
  resumeSyncIntervalMs: 2 * 60 * 60 * 1000,
  memoryCacheTtlMs: 5 * 60 * 1000,
};

/**
 * 合并用户策略与默认值。
 *
 * @param partial - 部分策略
 * @returns 完整策略
 */
export function resolveSyncPolicy(partial?: Partial<I18nSyncPolicy>): I18nSyncPolicy {
  return {
    ...DEFAULT_SYNC_POLICY,
    ...partial,
  };
}
